module.exports = __webpack_public_path__ + "static/media/logo-square.4b0188f0.png";